"use client";

import React from "react";
import IndiqGSTSimulation from "../components/IndiqGSTSimulation";

export default function IndiqGSTPage() {
  return (
    <div>
      <IndiqGSTSimulation />
    </div>
  );
}
